export interface ComposerAttachmentRevealOptions {
  onSettled: () => void
  settleMs: number
}

function prefersReducedMotion(): boolean {
  return window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false
}

export function scheduleComposerAttachmentReveal(
  scrollHost: HTMLElement,
  assetId: string,
  options: ComposerAttachmentRevealOptions,
): (() => void) | null {
  const attachment = scrollHost.querySelector<HTMLElement>(`[data-asset-id="${assetId}"]`)
  if (!attachment) return null

  const reduceMotion = prefersReducedMotion()
  attachment.scrollIntoView({
    behavior: reduceMotion ? 'auto' : 'smooth',
    block: 'center',
    inline: 'nearest',
  })
  if (reduceMotion) {
    options.onSettled()
    return () => undefined
  }

  const timer = window.setTimeout(options.onSettled, options.settleMs)
  return () => window.clearTimeout(timer)
}
